"use client";

import { Button, Text } from "@pamperedchef/design-system";
import * as styles from "./stubs.module.scss";

export interface PlpResultsToolbarProps {
	/** Placeholder result count. */
	itemCount?: number;
}

/** STUB results toolbar — item count on the left, a Sort By trigger on the right. */
export function PlpResultsToolbar({
	itemCount = 42
}: PlpResultsToolbarProps): JSX.Element {
	return (
		<div
			className={`${styles["spread"]} ${styles["section"]}`}
			data-component="PlpResultsToolbar"
		>
			<Text tag="span" styledAs="smr">{`${itemCount} Items`}</Text>
			<Button kind="secondary" size="sm">
				Sort By: Relevance
			</Button>
		</div>
	);
}
